<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/credores" back-text="Credores">
            <v-btn v-if="$allowed('edit')" type="button" color="primary" depressed @click=updateUser()>Atualizar</v-btn>
        </ui-page-header>

        <v-banner v-if="!isFilledDate(dataset.data.account_verified_at)" single-line outlined class="mb-4">
            <v-icon slot="icon" color="warning" size="36">
                mdi-alert-outline
            </v-icon>
            Este credor ainda não verificou o cadastro

            <template v-slot:actions>
                <v-btn color="primary" text @click="verifyAccount()">
                    VERIFICAR AGORA
                </v-btn>
            </template>
        </v-banner>
        <v-banner v-if="isFilledDate(dataset.data.account_approved_at) && dataset.data.type === 1" single-line outlined class="mb-4">
            <v-icon slot="icon" color="accent" size="36">
                mdi-check-circle-outline
            </v-icon>
            Este credor está incluso na lista de credores
        </v-banner>

        <v-form :readonly="!$allowed('save')" ref="form" v-model="dataForm.validForm" class="mb-4">
            <ui-section title="Detalhes">
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field dense id="name" label="Nome completo" v-model="dataset.data.name"
                            required :rules="[$rules.required]" outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field dense label="E-mail" v-model="dataset.data.email" required
                            outlined hide-details="auto" :disabled="dataset.data.type === 3">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field dense id="registration" label="CPF/CNPJ"
                            v-model="dataset.data.registration" required @input="formatRegistration()"
                            :rules="[$rules.required, (dataset.data.registration && dataset.data.registration.length < 15 ? $rules.cpf : $rules.cnpj)]"
                            outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                </v-row>
            </ui-section>
        </v-form>

        <ui-section title="Ações">
            <v-btn type="button" color="primary" outlined :href="dataset.data.documentUrl"
                target="_blank">Visualizar
                documento</v-btn>
            <!-- <v-btn v-if="$allowed('edit')" type="button" elevation="0" color="primary" outlined >Aprovar</v-btn> -->
            <v-btn
                type="button"
                depressed
                :color="dataset.data.status === 0 ? 'error' : 'accent'"
                @click=blockUser()
                class="ml-3">
                {{ dataset.data.status === 0 ? 'Bloquear' : 'Desbloquear' }}
            </v-btn>
        </ui-section>

        <ui-section title="Cadastro complementar">
            <v-alert v-if="profile.update_requested" type="warning" outlined dense>
                Atualização solicitada em {{ formatDateTime(profile.update_requested_at) }}. Motivo: {{ profile.update_reason }}
            </v-alert>
            <v-row>
                <v-col cols="12" sm="3">
                    <div class="ui-label">Tipo de pessoa</div>
                    <div class="font-weight-medium">{{ personTypeLabel }}</div>
                </v-col>
                <v-col cols="12" sm="9">
                    <div class="ui-label">Endereço</div>
                    <div class="font-weight-medium">{{ fullAddress || "Não informado" }}</div>
                </v-col>
            </v-row>
            <v-row v-if="profile.person_type === 'pj'">
                <v-col cols="12" sm="5">
                    <div class="ui-label">Representante legal</div>
                    <div class="font-weight-medium">{{ dataset.data.legal_rep_name || "Não informado" }}</div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div class="ui-label">CPF do representante</div>
                    <div class="font-weight-medium">{{ dataset.data.legal_rep_registration ? formatCpfCnpj(dataset.data.legal_rep_registration) : "Não informado" }}</div>
                </v-col>
                <v-col cols="12" sm="4">
                    <div class="ui-label">Cargo</div>
                    <div class="font-weight-medium">{{ dataset.data.legal_rep_role || "Não informado" }}</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="ui-label">Pendências para adesão ao plano</div>
                    <ui-badge v-if="!profile.missing.length" tone="success" text="Cadastro completo" />
                    <ui-badge v-for="item in profile.missing" :key="item.key" class="mr-2 mt-1"
                        :tone="item.kind === 'document' ? 'warning' : 'neutral'" :text="item.label" />
                </v-col>
            </v-row>
            <!-- Documentos societarios: a adesao ao plano so libera com o mais recente de cada tipo aprovado -->
            <v-row v-if="profile.person_type === 'pj'">
                <v-col cols="12">
                    <div class="ui-label mb-1">Documentos societários</div>
                    <div v-if="!companyDocs.length" class="ui-muted ui-small">Nenhum documento enviado pelo credor.</div>
                    <v-simple-table v-else dense>
                        <thead>
                            <tr>
                                <th>Documento</th>
                                <th>Arquivo</th>
                                <th>Enviado em</th>
                                <th>Situação</th>
                                <th class="text-right">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doc in companyDocs" :key="`company-doc-${doc.id}`" :class="{ 'company-doc--old': !doc.current }">
                                <td>
                                    {{ doc.type_label }}
                                    <div v-if="!doc.current" class="ui-muted ui-small">Substituído por envio mais recente</div>
                                </td>
                                <td>{{ doc.name }}</td>
                                <td class="text-no-wrap">{{ formatDateTime(doc.created_at) }}</td>
                                <td>
                                    <ui-badge :tone="companyDocStatus(doc).tone" :text="companyDocStatus(doc).text" />
                                    <div v-if="doc.review_reason" class="ui-small mt-1">Motivo: {{ doc.review_reason }}</div>
                                    <div v-if="doc.reviewed_at" class="ui-muted ui-small">
                                        {{ formatDateTime(doc.reviewed_at) }}<span v-if="doc.reviewed_by_name"> · {{ doc.reviewed_by_name }}</span>
                                    </div>
                                </td>
                                <td class="text-right text-no-wrap">
                                    <v-btn v-if="doc.url" icon small :href="doc.url" target="_blank" title="Abrir documento"><v-icon small>mdi-open-in-new</v-icon></v-btn>
                                    <template v-if="doc.current">
                                        <!-- Ja analisado: so desfaz a analise (volta para "em analise") -->
                                        <v-tooltip v-if="doc.status === 1 || doc.status === 2" bottom>
                                            <template #activator="{ on, attrs }">
                                                <v-btn icon small v-bind="attrs" v-on="on" :loading="companyDocReview.loadingId === doc.id"
                                                    @click="reviewCompanyDoc(doc, 0)"><v-icon small>mdi-restore</v-icon></v-btn>
                                            </template>
                                            <span>Voltar para "em análise"</span>
                                        </v-tooltip>
                                        <template v-else>
                                            <v-btn v-if="$allowed('edit')" small text color="success" :loading="companyDocReview.loadingId === doc.id"
                                                @click="reviewCompanyDoc(doc, 1)">Aprovar</v-btn>
                                            <v-btn v-if="$allowed('edit')" small text color="error" :disabled="companyDocReview.loadingId === doc.id"
                                                @click="openRejectCompanyDoc(doc)">Recusar</v-btn>
                                        </template>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <template #footer>
                <v-btn v-if="!profile.update_requested" color="primary" outlined
                    @click="profileRequest.dialog = true">Solicitar atualização cadastral</v-btn>
                <v-btn v-else color="error" outlined :loading="profileRequest.loading"
                    @click="cancelProfileUpdateRequest()">Cancelar solicitação</v-btn>
            </template>
        </ui-section>

        <ui-section title="Comprovantes de Pagamento">
            <v-row v-if="dataset.data.payment_receipts && dataset.data.payment_receipts.length > 0">
                <v-col cols="12" sm="4" md="3" v-for="(receipt, idx) in dataset.data.payment_receipts" :key="idx">
                    <div class="ui-card text-center pa-4">
                        <v-icon size="40" color="primary">mdi-file-document-check-outline</v-icon>
                        <div class="mt-2 mb-1 font-weight-medium">Comprovante de pagamento</div>
                        <div class="mb-3 ui-muted ui-small">{{ receipt.client_name }}</div>
                        <v-btn type="button" color="primary" outlined small
                            :href="receipt.url" target="_blank">
                            Visualizar
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <div class="ui-divider" v-if="dataset.data.payment_receipts && dataset.data.payment_receipts.length > 0"></div>

            <v-row align="center">
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        dense
                        outlined
                        hide-details="auto"
                        v-model="dataset.receipt_client_id"
                        :items="dataset.clients"
                        item-text="name"
                        item-value="id"
                        label="Selecione a Devedora"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="5">
                    <v-file-input
                        dense
                        outlined
                        v-model="dataset.payment_receipt_file"
                        accept="image/png, image/jpeg, application/pdf"
                        prepend-icon=""
                        prepend-inner-icon="mdi-paperclip"
                        label="Anexar comprovante de pagamento"
                        hide-details="auto"
                    ></v-file-input>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-btn v-if="$allowed('edit')" color="primary" depressed @click="uploadReceipt" :loading="dataset.uploadingReceipt" block>
                        Enviar
                    </v-btn>
                </v-col>
            </v-row>
        </ui-section>

        <ui-section title="Dados Bancários">
            <template #actions>
                <v-btn outlined small color="primary" @click="downloadBankInfoCsv()" :loading="dataset.downloadingCsv">
                    <v-icon left small>mdi-file-excel</v-icon>
                    Baixar planilha (Excel)
                </v-btn>
            </template>

            <template v-if="dataset.bankInfo">
                <v-row>
                    <v-col cols="12" :sm="dataset.bankInfo.lawyer_id ? 6 : 12">
                        <v-text-field dense label="Titularidade da conta"
                            :value="dataset.bankInfo.lawyer_id ? 'Conta de Procurador' : 'Conta Própria'"
                            readonly outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="dataset.bankInfo.lawyer_id">
                        <v-text-field dense label="Nome do Procurador"
                            :value="dataset.bankInfo.lawyer ? dataset.bankInfo.lawyer.name : 'Nome indisponível'"
                            readonly outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row class="mt-2">
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Nome do banco" :value="dataset.bankInfo.bank_name" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Número do banco" :value="dataset.bankInfo.bank_code" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="12" sm="4">
                        <v-text-field dense label="Agência" :value="dataset.bankInfo.agency" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5">
                        <v-text-field dense label="Número da conta" :value="dataset.bankInfo.account_number" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field dense label="Dígito" :value="dataset.bankInfo.account_digit" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Tipo de conta" :value="dataset.accountTypes[dataset.bankInfo.account_type]" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="CPF/CNPJ" :value="dataset.bankInfo.registration ? formatCpfCnpj(dataset.bankInfo.registration) : ''" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Tipo de chave PIX" :value="dataset.pixKeyTypes[dataset.bankInfo.pix_type]" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Chave PIX" :value="dataset.bankInfo.pix_key" readonly disabled outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
            </template>
            <v-alert v-else type="info" outlined dense class="mb-0">
                Nenhum dado bancário cadastrado para este credor.
            </v-alert>
        </ui-section>

        <ui-section title="Movimentações">
            <div v-for="(item, index) in dataset.events" :key="index" class="py-1">
                <span class="font-weight-medium">{{ getTitleByTypeEvent(item) }}:</span> {{ getMessageByTypeEvent(item) }}
            </div>
            <div v-if="!dataset.events.length" class="ui-muted">
                Nenhuma movimentação encontrada
            </div>
        </ui-section>

        <!-- Comprovantes dos e-mails enviados a este credor -->
        <ui-section v-if="!page.isNew" title="E-mails enviados">
            <template #actions>
                <v-btn small text color="primary" :loading="emailLogs.loading" @click="loadEmailLogs">
                    <v-icon left small>mdi-refresh</v-icon> Atualizar
                </v-btn>
                <v-btn small text color="primary" @click="openEmailLogList">Ver todos</v-btn>
            </template>
            <v-alert v-if="emailLogs.lastFailure" dense text type="warning" class="mb-3">
                O último e-mail para este credor não chegou ({{ emailLogs.lastFailure.kind_label }},
                {{ emailLogs.lastFailure.created_at | defaultDate("DD/MM/YYYY HH:mm") }}).
                Verifique se o endereço de e-mail do cadastro está correto.
            </v-alert>
            <v-data-table :headers="emailLogs.headers" :items="emailLogs.data" :loading="emailLogs.loading"
                disable-sort hide-default-footer :items-per-page="-1" dense
                no-data-text="Nenhum e-mail enviado para este credor"
                loading-text="Carregando e-mails...">
                <template v-slot:[`item.subject`]="{ item }">
                    <div class="ui-cell-main">{{ item.subject || "—" }}</div>
                    <div class="ui-cell-sub">{{ item.kind_label }}</div>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <ui-badge :text="item.status_label" :color="emailStatusColor(item.status)" />
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Baixar comprovante em PDF', icon: 'mdi-file-pdf-box', handler: () => downloadEmailReceipt(item) },
                    ]" />
                </template>
            </v-data-table>
        </ui-section>

        <!-- Solicitacoes de documentos feitas ao credor pela Central: o que foi recebido e o que falta -->
        <ui-section v-if="dataset.documentRequests.length" title="Documentos solicitados">
            <div v-for="request in dataset.documentRequests" :key="`doc-request-${request.id}`" class="ui-card pa-4 mb-3">
                <div class="d-flex align-center justify-space-between flex-wrap mb-2" style="gap: 8px;">
                    <div>
                        <span class="ui-cell-main">Solicitação #{{ request.id }}</span>
                        <span v-if="request.client_name" class="ui-muted ml-2">{{ request.client_name }}</span>
                        <div class="ui-small ui-muted">
                            Enviada em {{ request.created_at | defaultDate('DD/MM/YYYY') }} · prazo {{ request.deadline | defaultDate('DD/MM/YYYY') }}
                            <span v-if="request.is_closed"> · encerrada</span>
                        </div>
                        <!-- Ciencia do atraso confirmada no pop-up do site (credor ou procurador). -->
                        <div v-if="(request.overdue_acks || []).length" class="ui-small">
                            <v-icon x-small color="warning" class="mr-1">mdi-alert-circle-check-outline</v-icon>
                            Ciência do atraso: {{ request.overdue_acks[0].name || request.overdue_acks[0].email }}
                            em {{ request.overdue_acks[0].acknowledged_at | defaultDate('DD/MM/YYYY HH:mm') }}
                            <span v-if="request.overdue_acks.length > 1" class="ui-muted">({{ request.overdue_acks.length }} confirmações)</span>
                        </div>
                    </div>
                    <ui-badge :color="request.pending_count ? (request.is_closed ? 'error' : 'warning') : 'success'"
                        :text="`${request.received_count} de ${request.documents.length} recebido(s)`" />
                </div>
                <div v-if="request.justification" class="mb-2">
                    <span class="font-weight-medium">Justificativa do credor:</span> <span v-html="request.justification"></span>
                </div>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Documento</th>
                            <th>Situação</th>
                            <th>Recebido em</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="document in request.documents" :key="`doc-${document.id}`">
                            <td>{{ document.name }}</td>
                            <td>
                                <ui-badge :text="document.tag"
                                    :color="document.file_url ? (document.uploaded_after_deadline ? 'error' : 'success') : (request.is_closed ? 'grey' : 'warning')" />
                            </td>
                            <td>{{ document.uploaded_at ? $options.filters.defaultDate(document.uploaded_at, 'DD/MM/YYYY HH:mm') : '—' }}</td>
                            <td>
                                <div v-if="document.files && document.files.length" class="d-flex flex-column">
                                    <a v-for="file in document.files" :key="`file-${document.id}-${file.id}`" :href="file.url" target="_blank" class="text-no-wrap">
                                        <v-icon small>mdi-download</v-icon> {{ file.name }}
                                    </a>
                                </div>
                                <v-btn v-else-if="document.file_url" icon small :href="document.file_url" target="_blank"><v-icon small>mdi-download</v-icon></v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
        </ui-section>

        <!-- Credenciamentos excluidos administrativamente, com o motivo. Visivel so aqui, sem e-mail ao credor. -->
        <ui-section v-if="dataset.accreditationDeletions.length" title="Credenciamentos excluídos" flush>
            <v-simple-table dense>
                <thead>
                    <tr>
                        <th>Assembleia</th>
                        <th>Caso</th>
                        <th>Excluído em</th>
                        <th>Por</th>
                        <th>Motivo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in dataset.accreditationDeletions" :key="`deletion-${item.id}`">
                        <td>{{ item.general_meeting_name || '—' }}</td>
                        <td>{{ item.client_name || '—' }}</td>
                        <td>{{ item.deleted_at | defaultDate('DD/MM/YYYY HH:mm') }}</td>
                        <td>{{ item.deleted_by_name || '—' }}</td>
                        <td><div class="deletion-reason" v-html="item.deletion_reason"></div></td>
                    </tr>
                </tbody>
            </v-simple-table>
        </ui-section>

        <v-dialog v-model="profileRequest.dialog" max-width="560">
            <div class="ui-card">
                <header class="ui-card__header">
                    <h3 class="ui-section-title">Solicitar atualização cadastral</h3>
                </header>
                <div class="ui-card__body">
                    <p>O credor receberá um e-mail e verá um aviso em "Minha conta". A solicitação é encerrada automaticamente quando as pendências forem resolvidas.</p>
                    <v-textarea v-model="profileRequest.reason" label="Motivo" outlined rows="3" auto-grow counter="500" maxlength="500"></v-textarea>
                </div>
                <footer class="ui-card__footer">
                    <v-btn text @click="profileRequest.dialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('edit')" color="primary" depressed :disabled="!profileRequest.reason.trim()" :loading="profileRequest.loading"
                        @click="requestProfileUpdate()">Enviar solicitação</v-btn>
                </footer>
            </div>
        </v-dialog>

        <v-dialog v-model="companyDocReview.dialog" max-width="560">
            <div class="ui-card">
                <header class="ui-card__header">
                    <h3 class="ui-section-title">Recusar documento</h3>
                </header>
                <div class="ui-card__body">
                    <p>
                        <strong>{{ companyDocReview.doc && companyDocReview.doc.type_label }}</strong>.
                        O credor verá o motivo em "Minha conta" e precisará enviar o documento de novo. A adesão ao plano fica bloqueada até um novo envio ser aprovado.
                    </p>
                    <v-textarea v-model="companyDocReview.reason" label="Motivo da recusa" outlined rows="3" auto-grow counter="500" maxlength="500"></v-textarea>
                </div>
                <footer class="ui-card__footer">
                    <v-btn text @click="companyDocReview.dialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('edit')" color="error" depressed :disabled="!companyDocReview.reason.trim()" :loading="!!companyDocReview.loadingId"
                        @click="reviewCompanyDoc(companyDocReview.doc, 2, companyDocReview.reason)">Recusar documento</v-btn>
                </footer>
            </div>
        </v-dialog>
    </div>
</template>
  
<script>
import { downloadBlob } from "@/common/util/export-xlsx.util";
import states from "@/common/data/states.data"
import sanitizers from '@/common/util/string.js'
import { cpf, cnpj } from 'cpf-cnpj-validator'

import userTypes from "@/common/data/user-types.data"

import axios from "axios"

export default {
    name: "UserDetails",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            // Credenciamentos excluidos administrativamente (motivo visivel so aqui)
            accreditationDeletions: [],
            // Solicitacoes de documentos feitas ao credor pela Central
            documentRequests: [],
            userTypes: userTypes,
            breadcrumbItems: [],
            states: states,
            clients: [],
            data: {
                registration: "",
                payment_receipt_url: null,
            },
            events: [],
            bankInfo: null, 
            downloadingCsv: false,
            accountTypes: { 1: "Conta corrente", 2: "Conta poupança" },
            pixKeyTypes: { 1: "CPF", 2: "CNPJ", 3: "Celular", 4: "E-mail", 5: "Chave Aleatória" },
            payment_receipt_file: null, 
            receipt_client_id: null,
            uploadingReceipt: false,
        },
        profileRequest: {
            dialog: false,
            reason: "",
            loading: false,
        },
        // Analise dos documentos societarios (aprovar/recusar)
        companyDocReview: {
            dialog: false,
            doc: null,
            reason: "",
            loadingId: null,
        },
        // Comprovantes dos e-mails enviados a este credor
        emailLogs: {
            data: [],
            loading: false,
            lastFailure: null,
            headers: [
                { text: "Assunto", value: "subject" },
                { text: "Enviado em", value: "created_at" },
                { text: "Situação", value: "status", align: "center" },
                { text: "", value: "actions", align: "end", sortable: false, width: 56 },
            ],
        },

        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
    }),

    computed: {
        profile() {
            const status = this.dataset.data.profile_completeness || {};
            return {
                person_type: status.person_type || null,
                missing: status.missing || [],
                update_requested: !!status.update_requested,
                update_requested_at: status.update_requested_at || null,
                update_reason: status.update_reason || "",
            };
        },
        companyDocs() {
            return this.dataset.data.company_docs || [];
        },
        personTypeLabel() {
            if (this.profile.person_type === "pj") return "Pessoa jurídica";
            if (this.profile.person_type === "pf") return "Pessoa física";
            return "Não identificado";
        },
        fullAddress() {
            const d = this.dataset.data;
            if (!d.street) return "";
            const zip = d.zip_code ? String(d.zip_code).replace(/^(\d{5})(\d{3})$/, "$1-$2") : "";
            return [
                [d.street, d.address_number].filter(Boolean).join(", "),
                d.address_complement,
                d.district,
                [d.city, d.state].filter(Boolean).join("/"),
                zip && `CEP ${zip}`,
            ].filter(Boolean).join(" · ");
        },
    },

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData()
    },

    methods: {

        async loadClients() {
            try {
                const result = await axios.get('/api/clients', { 
                    params: { start: 1, limit: 1000 } 
                });

                if (result.data && result.data.content && result.data.content.data) {
                    const data = result.data.content.data;
                    
                    data.sort((a, b) => a.name.localeCompare(b.name));
                    
                    this.dataset.clients = data;
                }
            } catch (error) {
                console.error("Erro ao carregar as devedoras:", error);
            }
        },

        goBack() {
            this.$router.replace("/credores");
        },

        getMessageByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `Credor acessou o sistema no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'approve-user':
                    result = `Credor foi incluído na lista no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'accept-value':
                    result = `Credor aceitou o crédito no valor de R$ ${this.dataset.data.requested_value} no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'verify-account':
                    result = `Credor verificou a conta no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'register-user':
                    result = `Credor criou a conta no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'create-event':
                    result = `Credor registrou uma divergência no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                default:
                    break;
            }

            return result;
        },

        getTitleByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `acesso`;
                    break;

                case 'approve-user':
                    result = `LISTA`;
                    break;

                case 'accept-value':
                    result = `CRÉDITO`;
                    break;

                case 'verify-account':
                    result = `verificação`;
                    break;

                case 'register-user':
                    result = `cadastro`;
                    break;

                case 'create-event':
                    result = `divergência`;
                    break;

                default:
                    break;
            }

            return result;
        },

        async loadData() {
            await this.load();
            await this.loadBankInfo();
            await this.loadEvents();
            await this.loadAccreditationDeletions();
            await this.loadDocumentRequests();
            await this.loadEmailLogs();
            await this.loadClients();
        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        isFilledDate(value) {
            return !!value && value !== '0000-00-00 00:00:00' && value !== '0000-00-00';
        },

        formatRegistration() {
            this.dataset.data.registration = this.formatCpfCnpj(this.dataset.data.registration);
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = "Detalhes do credor";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Credores",
                disabled: false,
                to: "/credores",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: "Detalhes do credor",
                disabled: true,
                exact: true,
            });
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o credor?',
                title: 'Atualizar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/users/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Credor salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async approveUser() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja aprovar o credor?',
                title: 'Aprovar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Aprovar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const response = await axios.post(`/api/admin/users/approve/${this.$route.params.id}`, {});

                this.$dialog.notify.info("Credor aprovado com sucesso", { position: "top-right", timeout: 2000 });

                this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async verifyAccount() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja verificar a conta?',
                title: 'Verificar conta',
                actions: {
                    false: 'Cancelar',
                    true: 'Verificar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const response = await axios.post(`/api/admin/users/verify-account/${this.$route.params.id}`, {});

                this.$dialog.notify.info("Conta verificada com sucesso", { position: "top-right", timeout: 2000 });

                this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        // ---- E-mails enviados a este credor ----
        async loadEmailLogs() {
            if (!this.$route.params.id || this.page.isNew) return;
            this.emailLogs.loading = true;
            try {
                const result = await axios.get(`/api/admin/users/${this.$route.params.id}/email-logs`, { params: { limit: 20 } });
                const content = result.data.content || {};
                this.emailLogs.data = content.data || [];
                this.emailLogs.lastFailure = content.last_failure || null;
            } catch (error) {
                this.emailLogs.data = [];
                this.emailLogs.lastFailure = null;
            } finally {
                this.emailLogs.loading = false;
            }
        },

        emailStatusColor(status) {
            return ({ delivered: "success", queued: "warning", failed: "error", rejected: "error", error: "grey darken-1" })[status] || "grey";
        },

        openEmailLogList() {
            this.$router.push({ path: "/emails", query: { user_id: this.$route.params.id } });
        },

        async downloadEmailReceipt(item) {
            try {
                const result = await axios.get(`/api/admin/email-logs/${item.id}/receipt`, { responseType: "blob" });
                const url = window.URL.createObjectURL(new Blob([result.data], { type: "application/pdf" }));
                window.open(url, "_blank");
                setTimeout(() => window.URL.revokeObjectURL(url), 60000);
            } catch (error) {
                this.$dialog.notify.error("Não foi possível gerar o comprovante.", { position: "top-right", timeout: 4000 });
            }
        },

        async loadDocumentRequests() {
            try {
                const result = await axios.get(`/api/admin/users/${this.$route.params.id}/document-requests`);
                this.dataset.documentRequests = Array.isArray(result.data.content) ? result.data.content : [];
            } catch (error) {
                this.dataset.documentRequests = [];
            }
        },

        async loadAccreditationDeletions() {
            try {
                const result = await axios.get(`/api/admin/users/${this.$route.params.id}/accreditation-deletions`);
                this.dataset.accreditationDeletions = Array.isArray(result.data.content) ? result.data.content : [];
            } catch (error) {
                this.dataset.accreditationDeletions = [];
            }
        },

        formatDateTime(value) {
            return value ? new Date(value).toLocaleString("pt-BR") : "";
        },

        async requestProfileUpdate() {
            this.profileRequest.loading = true;
            try {
                const result = await axios.post(`/api/admin/users/${this.$route.params.id}/request-profile-update`, {
                    reason: this.profileRequest.reason.trim(),
                });
                this.$set(this.dataset.data, "profile_completeness", result.data.content);
                this.profileRequest.dialog = false;
                this.profileRequest.reason = "";
                this.$dialog.notify.success("Solicitação enviada ao credor", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.profileRequest.loading = false;
            }
        },

        companyDocStatus(doc) {
            if (doc.status === 1) return { tone: "success", text: "Aprovado" };
            if (doc.status === 2) return { tone: "danger", text: "Recusado" };
            return { tone: "warning", text: "Em análise" };
        },

        openRejectCompanyDoc(doc) {
            this.companyDocReview.doc = doc;
            this.companyDocReview.reason = "";
            this.companyDocReview.dialog = true;
        },

        async reviewCompanyDoc(doc, status, reason = "") {
            this.companyDocReview.loadingId = doc.id;
            try {
                const result = await axios.post(`/api/admin/user-docs/${doc.id}/review`, { status, reason: reason.trim() });
                this.$set(this.dataset.data, "company_docs", result.data.content.company_docs);
                this.$set(this.dataset.data, "profile_completeness", result.data.content.profile_completeness);
                this.companyDocReview.dialog = false;
                this.$dialog.notify.success(["Documento voltou para análise", "Documento aprovado", "Documento recusado"][status], { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.companyDocReview.loadingId = null;
            }
        },

        async cancelProfileUpdateRequest() {
            this.profileRequest.loading = true;
            try {
                const result = await axios.delete(`/api/admin/users/${this.$route.params.id}/request-profile-update`);
                this.$set(this.dataset.data, "profile_completeness", result.data.content);
                this.$dialog.notify.success("Solicitação cancelada", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.profileRequest.loading = false;
            }
        },

        async load() {

            try {
                const result = await axios.get(`/api/admin/users/${this.$route.params.id}`);

                this.dataset.data = result.data.content;
                this.dataset.data.payment_receipt_url = result.data.content.payment_receipt_url || null;

                const registration = this.dataset.data.registration;
                if (registration) {
                    this.dataset.data.registration = registration.length < 14 ?  cpf.format(registration) : cnpj.format(registration) ;
                }
                 
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadEvents() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/user-logs/user/${this.$route.params.id}`);

                this.dataset.events = result.data.content;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                description: this.dataset.data.description,
                client: this.dataset.data.client,
                unit: this.dataset.data.unit,
                associations: this.normalizeAssociations(),
                credential: {
                    username: this.dataset.data.email,
                    password: this.dataset.data.password,
                },
                roles: this.dataset.data.roles

            }

            return data;
        },

        async updateUser() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os dados do credor?<br><br>Note que efetuar alteração no email ou CPF/CNPJ do credor, poderá causar instabilidade na identificação e acesso do mesmo ao sistema.',
                title: 'Atualizar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                registration: sanitizers.sanitizeCpfCnpj(this.dataset.data.registration)
            }

            try {
                const response = await axios.patch(`/api/admin/users/update/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Credor atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async blockUser() {

            const isBlocked = this.dataset.data.status === 3;
            const text = isBlocked ? 'Deseja desbloquear o credor?' : 'Deseja bloquear o credor?';
            const title = isBlocked ? 'Desbloquear credor' : 'Bloquear credor';
            const actionTrue = isBlocked ? 'Desbloquear' : 'Bloquear';
            const payload = isBlocked ? 0 : 3;

            const proceedAction = await this.$dialog.confirm({
                text,
                title,
                actions: {
                false: 'Cancelar',
                true: actionTrue,
                },
            });
                        
            if (!proceedAction) return;

            try {
                const response = await axios.patch(`/api/admin/users/update/${this.$route.params.id}`, {status: payload});

                this.$dialog.notify.info(`Credor ${isBlocked ? 'desbloqueado' : 'bloqueado'} com sucesso!`, { position: "top-right", timeout: 3000 });

                this.goBack()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } 
        },

        async loadBankInfo() {
            try {
                const result = await axios.get(`/api/admin/users/${this.$route.params.id}/bank-information`);
                
                if (result.data.content && Array.isArray(result.data.content.data) && result.data.content.data.length > 0) {
                    this.dataset.bankInfo = result.data.content.data[0];
                } else if (result.data.content && !Array.isArray(result.data.content)) {
                    this.dataset.bankInfo = result.data.content;
                }
            } catch (error) {
                console.log("Credor não possui dados bancários vinculados.");
            }
        },

        async downloadBankInfoCsv() {
            this.dataset.downloadingCsv = true;
            try {
                const result = await axios.get(`/api/admin/users/${this.$route.params.id}/bank-information/csv`, {
                    responseType: 'blob' 
                });
                
                downloadBlob(result.data, `dados_bancarios_${this.dataset.data.name.replace(/\s+/g, '_')}`);
                
                this.$dialog.notify.info("Planilha gerada com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error("Erro ao gerar planilha. O credor possui dados cadastrados?", { position: 'top-right', timeout: 3000 });
            } finally {
                this.dataset.downloadingCsv = false;
            }
        },

        async uploadReceipt() {
            if (!this.dataset.receipt_client_id) {
                this.$dialog.notify.warning("Selecione a Devedora.", { position: 'top-right', timeout: 3000 });
                return;
            }
            if (!this.dataset.payment_receipt_file) {
                this.$dialog.notify.warning("Anexe um arquivo.", { position: 'top-right', timeout: 3000 });
                return;
            }

            this.dataset.uploadingReceipt = true;

            const formData = new FormData();
            formData.append("receipt", this.dataset.payment_receipt_file);
            formData.append("client_id", this.dataset.receipt_client_id); 

            try {
                await axios.patch(`/api/admin/users/${this.$route.params.id}/receipt`, formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                });

                this.$dialog.notify.info("Comprovante anexado e enviado com sucesso!", { position: "top-right", timeout: 2000 });
                
                this.dataset.payment_receipt_file = null;
                this.dataset.receipt_client_id = null; 
                
                await this.loadData(); 
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao enviar comprovante", { position: 'top-right', timeout: 3000 });
            } finally {
                this.dataset.uploadingReceipt = false;
            }
        },

    },
};
</script>
  
<style lang="scss">
.deletion-reason {
    max-width: 480px;
    white-space: normal;
    word-break: break-word;
}

.deletion-reason p {
    margin-bottom: 4px;
}

.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.company-doc--old td {
    opacity: 0.6;
}
</style>
